import { useContext, useCallback } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import uniq from 'lodash/uniq';

import { AuthContext } from '../contexts/AuthContext';

const mainMenuItems = require('../menu/mainMenuItems.json');

const rolesByFeature = {
  mission_roles: [10, 110, 130],
  builder_roles: [10, 120],
  checklist_roles: [10, 130],
  adduser_roles: [10, 110, 130],
  global_roles: [10],
};

const filterMenuTree = (
  menuItems,
  userRoles,
  userIsCurrentMissionAuthorized
) => {
  menuItems.forEach((menu) => {
    if (menu.subItems) {
      const filteredSubItems = menu.subItems.filter(
        (item) =>
          !item.roles ||
          item.roles?.find((role) => userRoles.filter((r) => r).includes(role))
      );

      menu.subItems = filteredSubItems;
    }
  });

  const newMenu = menuItems.filter(
    (item) =>
      item.id === 'home' ||
      item.id === 'my_check_lists' ||
      (item.id === 'my_tasks' && userIsCurrentMissionAuthorized) ||
      item.roles?.find((role) => userRoles.filter((r) => r).includes(role))
  );
  return newMenu;
};

function useAuthorization() {
  const { sessionStore, sessionHelpers } = useContext(AuthContext);
  const checkRoleByFeature = useCallback(
    (feature = 'my_tasks') => {
      if (!sessionHelpers.isAuthenticated()) {
        return false;
      } else if (feature === 'my_tasks') {
        return true;
      } else if (feature === 'my_check_lists') {
        return true;
      } else {
        const allRoles = uniq([
          ...sessionStore.userCurrentMissionRoles.map((item) => item.role),
        ]);

        const roles = rolesByFeature[feature];

        const isAuth = allRoles.some((item) => {
          return roles?.includes(item);
        });
        return isAuth;
      }
    },
    [sessionHelpers.isAuthenticated, sessionStore]
  );

  const getMenuItemsForUser = () => {
    const menuItems = cloneDeep(mainMenuItems);
    const userRoles = uniq([
      ...sessionStore.userCurrentMissionRoles.map((item) => item.role),
    ]);
    const userIsCurrentMissionAuthorized =
      (sessionStore && sessionStore.currentOrganizationId > 0) ?? false;
    return filterMenuTree(menuItems, userRoles, userIsCurrentMissionAuthorized);
  };

  return {
    checkRoleByFeature,
    getMenuItemsForUser,
  };
}

export default useAuthorization;
